import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Surface logic — first matching role wins. Customer-only users see no banner
// because their journey IS the public site.
const ROLE_RESUME = [
  { role: "master_admin",      to: "/admin",                    label: "Command Center" },
  { role: "admin",             to: "/admin",                    label: "Command Center" },
  { role: "training_admin",    to: "/admin",                    label: "Training Admin" },
  { role: "franchisee",        to: "/franchise",                label: "Franchise dashboard" },
  { role: "partner",           to: "/partner",                  label: "Partner dashboard" },
  { role: "driver",            to: "/delivery",                 label: "Delivery dashboard" },
  { role: "affiliate",         to: "/affiliate",                label: "Affiliate dashboard" },
  { role: "affiliate_trainer", to: "/training",                 label: "Trainer hub" },
  { role: "trainer",           to: "/training",                 label: "Trainer hub" },
  { role: "teacher",           to: "/training",                 label: "Trainer hub" },
];

export default function RoleContinue() {
  const { user } = useAuth();
  if (!user) return null;
  const roles = new Set(user.roles || []);
  const resume = ROLE_RESUME.find((r) => roles.has(r.role));
  if (!resume) return null;

  return (
    <Link
      to={resume.to}
      data-testid="role-continue-banner"
      className="inline-flex items-center gap-2 glass-panel px-4 py-2 text-xs font-bebas tracking-[0.18em] uppercase text-lifted-green hover:-translate-y-0.5 transition-transform"
    >
      Welcome back, {user.first_name || "Lifted"} — continue to {resume.label}
      <ArrowRight className="h-3 w-3" aria-hidden="true" />
    </Link>
  );
}
